import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-buyers-header',
  templateUrl: './buyers-header.component.html',
  styleUrls: ['./buyers-header.component.scss'],
})
export class BuyersHeaderComponent {
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  @Output() filter: EventEmitter<void> = new EventEmitter<void>();
}
